import React from "react";
import Contact from "../components/Contact.js";
import GetInTouch from "../components/GetInTouch.js";
import ProcessFollow from "../components/ProcessFollow.js";
import { Helmet } from "react-helmet-async";

const WebMobileSolutions = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <Helmet>
        Web Application
        <meta
          name="description"
          content="Boost your business with top-rated web application development services in India. Ayanshtech Solutions delivers secure, scalable & custom web apps for your growth."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Web Application Development Company In India | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/web-mobile-solutions"
        />
        <meta
          property="og:description"
          content="Boost your business with top-rated web application development services in India. Ayanshtech Solutions delivers secure, scalable & custom web apps for your growth."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Web Application Development Company In India | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Boost your business with top-rated web application development services in India. Ayanshtech Solutions delivers secure, scalable & custom web apps for your growth."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />
        <link
          rel="canonical"
          href="https://ayanshtechnology.com/web-mobile-solutions"
        />
        <title>
          Web Application Development Company In India | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className=" flex flex-col items-center justify-center mt-20 mb-6">
        <div className=" rounded-lg p-10  max-w-5xl lg:text-center md:text-center mb-20">
          <h1 className="sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Web Application Development Company in India
          </h1>
          <p className="text-lg text-gray-700 mb-2">
            As a trusted Web Application Development Company in India, we
            specialize in building custom web applications that deliver
            engaging, high-performing, and seamless user experiences. Our expert
            developers provide end-to-end web app development solutions,
            ensuring every project aligns perfectly with your business goals. We
            begin with a deep understanding of your project requirements,
            focusing on innovation, usability, and scalability to guarantee
            flawless implementation. From concept to deployment, our team
            ensures your web application stands out with robust functionality,
            modern design, and exceptional performance across all devices.
            Partner with us to transform your ideas into dynamic, result-driven
            web applications that empower your digital presence.
          </p>
          <button
            onClick={() =>
              window.scrollTo({ top: window.innerHeight, behavior: "smooth" })
            }
            className="mt-20 mb-10 bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 px-6 py-3 rounded-full"
          >
            Scroll Down
          </button>
        </div>

        <div className=" py-5 px-5 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="flex justify-center lg:w-1/4 mb-12 lg:mb-0">
              <img
                src="/assets/images/homeImages/webDesign.avif"
                alt="Web Application Development Company in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="lg:w-3/4  lg:text-left p-6">
              <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Leading Web Application Development Firm
              </h2>
              <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
                Elevate your business with a custom-built web application
                tailored to your unique needs. Since each organization operates
                differently, off-the-shelf solutions may not seamlessly fit into
                your existing processes. At Ayanshtech, we provide expert
                consulting and development services to deliver personalized web
                applications that cover comprehensive requirement analysis,
                rigorous testing, seamless delivery, and ongoing post-launch
                support.
                <br />
                <br />
                Our expertise spans a wide range of web solutions, catering to
                diverse businesses—from startups to well-established enterprises
                that are industry leaders. We aim to enhance the digital
                experience of your users with solutions designed to match your
                goals.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-4 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Our Contribution
          </h2>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-7xl mx-auto p-6">
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Expertise in building responsive and user-friendly websites.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Module development tailored to specific business requirements.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Plugin development to enhance platform functionality.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Implementing MVC, MVP design patterns for robust architecture.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Expertise in developing APIs and integrating third-party services.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Building PWAs for enhanced user engagement.
            </p>
          </div>
        </div>

        <div className=" mb-10 ">
          <div className="">
            <div className="text-center mt-10 mb-4 p-6">
              <h2 className="font-bold text-gray-800 mb-2 sm:text-3xl md:text-4xl lg:text-6xl">
                Technology Pool
              </h2>
            </div>
            <div className="flex justify-center">
              <div className="overflow-hidden max-w-7xl">
                <div className="flex animate-scroll-left gap-6">
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/nodeJs.svg"
                      alt="Angular Js"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/angularJs.svg"
                      alt="AngularJs"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/laravel.png"
                      alt="Laravel"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/flutter.svg"
                      alt="Flutter"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/kotlin.svg"
                      alt="Kotlin"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>

                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/magento.svg"
                      alt="Magento"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/mongoDb.svg"
                      alt="mongoDB"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/mySql.svg"
                      alt="mysql"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/nextJs.svg"
                      alt="Laravel"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/php.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/postgreSql.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/react.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/swift.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>

                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/vite.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/vueJs.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/assets/images/techStack/wordPress.svg"
                      alt="Mern Stack"
                      className="w-28 sm:w-28 md:w-36 lg:w-40 h-20 sm:h-20 md:h-28 lg:h-32 mx-auto object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full max-w-7xl bg-blue-800 text-white  rounded-3xl mt-10 mx-auto p-6">
          <div className=" mx-auto text-center flex justify-center md:justify-between items-center">
            <h2 className="text-xl md:text-2xl lg:text-3xl  ">
              Elevate Your Business to the Next Level!
            </h2>
            <button
              onClick={scrollToContact}
              className="bg-green-500 px-4 py-2 ml-6 rounded-full "
            >
              Get Started
            </button>
          </div>
        </div>

        <div className="text-center  mt-10 p-6">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Benefits of Choosing Our Web Development Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
            At Ayanshtech, we prioritize a seamless exchange of innovative ideas
            throughout every phase, ensuring code stability and adherence to
            best practices for our web application development services.
          </p>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-7xl mx-auto p-6">
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Flexible workflows to accommodate your unique ideas effortlessly.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Rigorous tools to validate and ensure code reliability.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Industry-standard coding practices to maintain professionalism.
            </p>
          </div>
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <p className="sm:text-base md:text-lg lg:text-xl">
              Your input and feedback remain at the forefront throughout the
              process.
            </p>
          </div>
        </div>

        <ProcessFollow />

        <div id="contact-section">
          <Contact />
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default WebMobileSolutions;
